import React from "react";
import { PageHeader } from "./PageHeader";
import CitiLight from "../img/citilight.jpg";

export const OpenDay = props => {
  return (
    <React.Fragment>
      <PageHeader title='Dzień otwarty "Fizycy zapraszają" '  />
      <div className="content-wrapper">
        <div className="main-content openday">
                <img src={CitiLight} className="" alt="Dzień otwarty"/>
        </div>
      </div>
    </React.Fragment>
  );
};

OpenDay.propTypes = {};
